import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import format from '@helpers/format_number';
import { localizeNumber, getMomentLocale } from '@helpers/locale';
import { defaultAttachment } from './helper';

import '@components/advanced_download/styles/header';

const Header = ({ attachment, closeModal, goBack }) => {
  const { filename, height, size, updated_at, width } = attachment.attributes;

  return (
    <header className="header">
      <button
        className="header--item go-back-button"
        onClick={goBack}
        type="button"
      >
        <span className="bff-left-arrow" />
        {t('Back to Overview')}
      </button>
      <ul className="header--list">
        <li><h4>{filename}</h4></li>
        <li><h4>{format(size)}</h4></li>
        <li><h4>{localizeNumber(width)} x {localizeNumber(height)}</h4></li>
        <li><h4>{moment(updated_at).locale(getMomentLocale()).format('L')}</h4></li>
      </ul>
      <button
        className="header--item close-button"
        onClick={closeModal}
        type="button"
      >
        <span className="bff-close" />
      </button>
    </header>
  );
};

Header.propTypes = {
  attachment: PropTypes.shape({
    attributes: PropTypes.shape({
      filename: PropTypes.string,
      height: PropTypes.number,
      size: PropTypes.number,
      width: PropTypes.number,
    })
  }),
  closeModal: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
};

Header.defaultProps = {
  attachment: defaultAttachment,
};

export default Header;
